import { render, staticRenderFns } from "./BusinessAutocomplete.vue?vue&type=template&id=496c35bc"
import script from "./BusinessAutocomplete.vue?vue&type=script&lang=js"
export * from "./BusinessAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./BusinessAutocomplete.vue?vue&type=style&index=0&id=496c35bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports